export enum UpdateFieldTypes {
    Text = 1,
    Number = 2,
    Date = 3,
    Datetime = 4,
    Checkbox = 5,
    Radio = 6,
    Currency = 7,
    Textarea = 8,
    Dropdown = 9
}

export  class UpdateFieldConstants {
    static activeFieldClassName = 'active-update-field';
    static inActiveFieldClassName = 'inactive-update-field';
    static updateFieldMainDivClassName = 'update-control-main-div';

    static fieldClassName = 'update-field';

    static updateFieldDefaultClassName = 'update-control-main-div inactive-update-field';
    static updateFieldActiveControlClassName = 'update-control-main-div active-update-field';
}

export interface IColumnDefinition {
    type: number;
    field: string;
    header: string;

    colWidth?: string;
    height?: number;
}

export class ColumnDefinition implements IColumnDefinition {
    public type: number;
    public field: string;
    public header: string;

    public height?: number;
    public colWidth?: string;
    public sorting: boolean;
}
